var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReinforce = function SvgReinforce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2091,
    height: 1362,
    viewBox: "-10 0 2091 1362"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m-10 951 383-499 383 499H546v411H200V951Zm662-226 383-499 383 499h-210v637H863V725ZM1698 0l383 500h-210v862h-346V500h-210z"
  })));
};
export default SvgReinforce;